import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type { Occupation } from '../../../../types/occupation'

const resource = 'occupations'

export const requests = {
  fetchOccupations: () => {
    return axiosForGigbaseBiz.get<DataResponse<Occupation[]>>(resource)
  },
}
